let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5XZOC")).then(() => parcelRequire('3Cy6F'));